<template>
  <div class="modal-body">
    <div class="mb-3">
      <label class="form-label">Ruolo predefinito</label>
      <select class="form-select" v-model="selectedRoleId">
        <option :value="null">Permessi personalizzati</option>
        <option v-for="role in filteredRoles" :key="role.id" :value="role.id">
          {{ role.description || role.name }}
        </option>
      </select>
    </div>

    <hr />

    <div class="row g-2">
      <div v-for="(group, id) in permissionGroups" :key="id" class="col-md-6">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" :id="'group-' + id" :value="Number(id)"
            v-model="selectedGroups" :disabled="isGroupDisabled(Number(id))" />
          <label class="form-check-label" :for="'group-' + id">
            {{ group.label }}
          </label>
        </div>
      </div>
    </div>
    <div v-if="blockedMessage" class="text-danger mt-2"> {{ blockedMessage }} </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-secondary" @click="$emit('close')">Annulla</button>
    <button class="btn btn-primary" @click="save">Salva</button>
  </div>
</template>
<script>
import { PERMISSION_GROUPS } from '../../../../components/permissionsGroup';

export default {
  name: 'UserPrivilegesForm',

  props: {
    modelValue: Object,          // manage permessi/privilegi dell'utente
    allPrivileges: Array,        // json con tutti i privilegi
    rolesWithPrivileges: Array   // i valori di defatul che arrivano dal db
  },

  data() {
    return {
      permissionGroups: PERMISSION_GROUPS,
      selectedGroups: [],
      selectedRoleId: null,
      originalPrivileges: [],
    };
  },

  computed: {
    filteredRoles() {
      const excludedRoles = [
        'sa-user',
        'administrator'
      ];
      const excludedIds = [7];

      return this.rolesWithPrivileges.filter(role =>
        !excludedIds.includes(role.id) &&
        !excludedRoles.includes(
          (role.name || role.description || '').toLowerCase()
        )
      );
    },
    resolvedPrivileges() {
      const map = new Map(this.allPrivileges.map(p => [p.name, p.id]));
      const set = new Set();

      this.selectedGroups.forEach(groupId => {
        const group = this.permissionGroups[groupId];
        group.privileges.forEach(pName => {
          if (map.has(pName)) set.add(map.get(pName));
        });
        group.autoIncludePrivileges?.forEach(pName => {
          if (map.has(pName)) set.add(map.get(pName));
        });
      });

      return [...set];
    }
  },

  watch: {
    modelValue: {
      immediate: true,
      handler(val) {
        if (!val?.privileges?.length) {
          this.selectedGroups = [];
          this.selectedRoleId = null;
          return;
        }

        const idToName = new Map(
          this.allPrivileges.map(p => [p.id, p.name])
        );

        const userPrivilegeNames = val.privileges
          .map(id => idToName.get(id))
          .filter(Boolean);

        this.selectedGroups = Object.entries(this.permissionGroups)
          .filter(([_, cfg]) =>
            cfg.privileges.every(pName =>
              userPrivilegeNames.includes(pName)
            )
          )
          .map(([id]) => Number(id));

        this.selectedRoleId = null;
        this.originalPrivileges = [...val.privileges];
      }
    },

    selectedGroups: {
      deep: true,
      handler(newVal) {

        const enabled = new Set(newVal);
        const disabled = new Set();

        newVal.forEach(id => {
          const cfg = this.permissionGroups[id];
          if (!cfg) return;

          cfg.autoEnable?.forEach(g => enabled.add(g));

          cfg.autoDisable?.forEach(g => {
            disabled.add(g);
            enabled.delete(g);
          });
        });

        disabled.forEach(g => enabled.delete(g));

        const finalValue = [...enabled].sort();

        const blockedGroups = newVal.filter(g => !finalValue.includes(g));

        if (blockedGroups.length) {
          this.blockedMessage = `Non puoi deselezionare '${blockedGroups.map(g => this.permissionGroups[g].label).join(', ')}' perché ci sono permessi dipendenti.`;

          this.$nextTick(() => {
            setTimeout(() => {
              this.blockedMessage = '';
            }, 1000);
          });
        }

        if (JSON.stringify(finalValue) !== JSON.stringify(this.selectedGroups)) {
          this.selectedGroups = finalValue;
        }
        else {

        }
      }
    },

    selectedRoleId(newRoleId) {
      if (!newRoleId) return;

      const role = this.rolesWithPrivileges.find(r => r.id === newRoleId);
      if (!role) return;

      const rolePrivIds = role.privileges.map(p => p.id);

      this.selectedGroups = Object.entries(this.permissionGroups)
        .filter(([_, cfg]) =>
          cfg.privileges.every(pName => {
            const priv = this.allPrivileges.find(p => p.name === pName);
            return priv && rolePrivIds.includes(priv.id);
          })
        )
        .map(([id]) => Number(id));
    }
  },

  methods: {
    isGroupDisabled(groupId) {
      const disabledByOther = this.selectedGroups.some(selectedId => {
        const selectedCfg = this.permissionGroups[selectedId];
        return selectedCfg?.autoDisable?.includes(groupId);
      });

      if (disabledByOther) return true;

      const enabledByOther = Object.entries(this.permissionGroups).some(([id, cfg]) => {
        id = Number(id);
        if (!this.selectedGroups.includes(id)) return false;
        return cfg.autoEnable?.includes(groupId);
      });

      return enabledByOther;
    },

    save() {
      /**const finalPrivileges = new Set(this.originalPrivileges);
      this.resolvedPrivileges.forEach(id => finalPrivileges.add(id));
      this.$emit('save', {
        userId: this.modelValue.userId,
        privileges: [...finalPrivileges].sort()
      });*/
      this.$emit('save', {
        userId: this.modelValue.userId,
        privileges: [...this.resolvedPrivileges].sort()
      });
    }
  }
};
</script>

<style scoped>
.modal-body {
  max-height: 60vh;
  overflow-y: auto;
}
</style>
